import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    width: 20px;
    height: 20px;
    border-radius: ${theme.border.radius.circle};
    background-color: ${theme.color.support.orange.weak};
    color: ${theme.color.support.orange.strong};
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: -${theme.spacing.km2};
    margin-right: -${theme.spacing.km2};
  `}
`;
